import { AggregateComposition, ConfigurationOverrides, EntityOverride } from '@blk/aw-bff-typescript-models';
import { LinkedEntity, OptimizationContext, SecurityValuationOverride } from '@blk/awt-aladdinportfoliobuilderserver';
import { AxiosResponse, CancelToken } from 'axios';
import { SleeveInfoTagValuePair } from './../AWPortfolio/SleeveInfos';
import { awBridgeApi } from './Base';
import { ProposalGeneratorInputs } from './Models';
import { BuyListItem, GenerateBuyListResponse, GenerateProposalResponseV1 } from './TempModels/GenerateProposal';

export interface BfmGenerateProposalRequest {
  aggregate: AggregateComposition;
  asOf: string;
  buyList?: Array<BuyListItem>;
  cancelToken?: CancelToken;
  configurationDirectory?: string;
  configurationOverrides?: ConfigurationOverrides;
  entityOverrides?: EntityOverride[];
  linkedEntities?: LinkedEntity[];
  parameters?: ProposalGeneratorInputs;
  pkg: string;
  reason?: string;
  securityValuationOverrides?: SecurityValuationOverride[];
  selectedSleeves?: SleeveInfoTagValuePair[];
}

export function postProposalGeneratorGenerateBuyList(
  request: BfmGenerateProposalRequest
): Promise<AxiosResponse<GenerateBuyListResponse>> {
  const path = '/v1/proposals/generateBuyList';
  return awBridgeApi.post(path, request, { params: { pkg: request.pkg } });
}

export function postProposalGeneratorGenerate(
  request: BfmGenerateProposalRequest
): Promise<AxiosResponse<GenerateProposalResponseV1>> {
  const path = '/v3/proposals/generate';
  return awBridgeApi.post(path, request);
}

export function postProposalGeneratorGenerateOptimizationContext(
  request: BfmGenerateProposalRequest
): Promise<AxiosResponse<OptimizationContext>> {
  const path = '/v1/proposals/generateOptimizationContext';
  return awBridgeApi.post(path, request);
}

// FIXME: deprecate and delete when client teams have fully migrated
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- existing any
export function postInsWrapper(request: any, path: string): Promise<AxiosResponse> {
  return awBridgeApi.post(path, request);
}
